import apiCall from 'components/Api/api';
import PackageWishLIst from 'components/wishlist/package/PackageWishLIst';
import SharedSafariWishlist from 'components/wishlist/sharedsafari/SharedSafariWishlist';
import { useAuth } from 'provider/AuthContext';
import { useWishListContext } from 'provider/WishListProvider';
import React, { useEffect, useRef } from 'react';
import { Col, Container, Row, Card, Tab, Nav } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from "components/Api/handleError";


const Wishlist = () => {
  const { tabslug } = useParams();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const prevPackRef = useRef();
  const prevSafariRef = useRef();
  const { activeTab,
    pageIndexPack,
    pageIndexSafari,
    wishListDispatch } = useWishListContext();
  //update url
  useEffect(() => {
    if (!activeTab) return;

    // Only update if URL doesn't match
    if (tabslug !== activeTab) {
      navigate(`/account/wishlist/${activeTab}`, { replace: true });
    }
  }, [activeTab, tabslug, navigate]);

  // for packages
  useEffect(() => {
    // Prevent duplicate API call
    const currentUrl = `account/wishlist-package` +
      `?page=${pageIndexPack}` +
      `&pageSize=3`
    if (prevPackRef.current === currentUrl) return;

    prevPackRef.current = currentUrl;

    const fetchWishlistPackage = async () => {


      try {
        console.count()
        wishListDispatch({ type: "SET_WISHLIST_PACKAGE_LOADING", payload: true });


        const response = await apiCall({
          url: currentUrl
        });

        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response?.data;

        if (apiData?.errors) {
          wishListDispatch({
            type: "SET_WISHLIST_PACKAGE_ERROR",
            payload: apiData.errors,
          });
          return;
        }

        const safariData = apiData?.packages?.data;
        const summary = apiData?.packages?.summary;
        if (pageIndexPack === 1) {
          wishListDispatch({
            type: "SET_WISHLIST_PACKAGE_DATA",
            payload: safariData,
          });
        } else {
          wishListDispatch({
            type: "APPEND_WISHLIST_PACKAGE_DATA",
            payload: safariData,
          });
        }

        wishListDispatch({
          type: "SET_WISHLIST_PACKAGE_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      } finally {
        wishListDispatch({ type: "SET_WISHLIST_PACKAGE_LOADING", payload: false });
      }
    };



    fetchWishlistPackage();

  }, [pageIndexPack]);

  // for share safari
  useEffect(() => {


    const currentUrl = `account/wishlist-shared-safari` +
      `?page=${pageIndexPack}` +
      `&pageSize=3`
    if (prevSafariRef.current === currentUrl) return;

    prevSafariRef.current = currentUrl;

    const fetchSharedSafari = async () => {

      try {
        console.count()
        wishListDispatch({ type: "SET_WISHLIST_SF_DATA_LOADING", payload: true });


        const response = await apiCall({
          url: currentUrl
        });

        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response?.data;

        if (apiData?.errors) {
          wishListDispatch({
            type: "SET_WISHLIST_SF_DATA_ERROR",
            payload: apiData.errors,
          });
          return;
        }

        const safariData = apiData?.share_safari?.data;
        const summary = apiData?.share_safari?.summary;
        if (pageIndexSafari === 1) {
          wishListDispatch({
            type: "SET_WISHLIST_SHARED_SAFARI_DATA",
            payload: safariData,
          });
        } else {
          wishListDispatch({
            type: "APPEND_WISHLIST_SHARED_SAFARI_DATA",
            payload: safariData,
          });
        }

        wishListDispatch({
          type: "SHARED_WISHLIST_SHARED_SAFARI_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      } finally {
        wishListDispatch({ type: "SET_WISHLIST_SF_DATA_LOADING", payload: false });
      }
    };

    fetchSharedSafari();

  }, [pageIndexSafari]);

  const handleTabClick = (tabname) => {
    wishListDispatch({ type: "SET_PROFILE_ACTIVE_TAB", payload: tabname });
  }


  return (
    <>
      <div className="">
        <Container fluid="lg" className="mt-5 pt-5" style={{ minHeight: "600px" }}>
          <Row className="margin_bottomfooter">
            <Col md={12} className='text-center text-lg-start text-xl-start text-xxl-start '>
              <h6 className="fs-3 fw-bold mb-4 ms-1">Wishlist</h6>
            </Col>
            <Row className='mx-xs-auto mx-md-auto mx-sm-auto mx-auto '>
            <Col xxl={3} lg={3} md={12} sm={12} xs={12}  className=" d-sm-block d-md-block d-lg-block mb-4 mt-md-2">
              <Card className="sidebar_account">
                <Card.Body className="nav nav-tabs flex-column nav-pills slider_accountsidebar">
                  <Nav.Link
                    eventKey="package"
                    as="button"
                    className={`nav-link mb-2 p-1 ${activeTab === 'package' ? 'active' : ''}`}
                    onClick={() => handleTabClick("package")}
                  >
                    Packages
                  </Nav.Link>
                  <Nav.Link
                    eventKey="shaerdsafari"
                    as="button"
                    className={`nav-link mb-2 p-1 ${activeTab === 'shaerdsafari' ? 'active' : ''}`}
                    onClick={() => handleTabClick("shaerdsafari")}
                  >
                    Shared Safaris
                  </Nav.Link>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={12} sm={12} lg={9} className=''>
              <Card className="account-settingside mb-5 itenary_tabs">
                <Card.Body className="card-body p-4 safartabs">
                  <Row>
                    <Col sm={12} md={12} >
                      <Tab.Container activeKey={activeTab}>
                        <Tab.Content id='pills-tabContent' className="px-3 pb-3">
                          <Tab.Pane eventKey="package" id="pills-packages" role="tabpanel" aria-labelledby="pills-shared-safari-tab">
                            {activeTab === 'package' && <PackageWishLIst />}
                          </Tab.Pane>

                          <Tab.Pane eventKey="shaerdsafari" id="pills-packages" role="tabpanel" aria-labelledby="pills-shared-safari-tab">
                            {activeTab === 'shaerdsafari' && <SharedSafariWishlist />}
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            </Row>
            
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Wishlist